import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { CustomImageHandler } from '../../../../../shared/components/CustomImageHandler';
import { getSocialIcons, truncateString } from '../../../../../shared/functions/Functions';
import { IContract } from '../../../../../model/shared/IContract';
import { useTranslation } from 'react-i18next';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import TooltipOverlay from '../../../../../shared/components/tooltip/Tooltip';
import Flag from '../../../../../shared/components/flag/Flag';
interface IContractOverviewAccordionProps {
    contract: IContract;
}

interface IAccordion {
    [key: number]: boolean;
}

export function ContractOverviewAccordion({ contract }: IContractOverviewAccordionProps) {
    const { t } = useTranslation();
    const [expended, setExpended] = useState<IAccordion>({});
    const getFullName = (user: any) => user.displayName || `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim();
    const fullName = getFullName(contract.user);
    const truncatedTitle = truncateString(fullName, 15);
    const isTruncated = fullName.length > 15;
    const h5Content = (
        <h5 className="px-2 ml-2 mb-0">
            {truncatedTitle}
            <div className="text-muted font-13 fw-normal mt-1">
                {`${contract.user.firstName ?? ''} ${contract.user.lastName ?? ''}`.trim()}
            </div>
        </h5>
    );

    return (
        <Accordion
            className="border-0 border-bottom"
            sx={{
                margin: 0,
                borderBottom: '1px solid #D9D9D9',

                '&.Mui-expanded': {
                    margin: 0,
                },
            }}
        >
            <AccordionSummary
                onClick={() =>
                    setExpended(prev => ({
                        ...prev,
                        [contract.id]: !prev[contract.id],
                    }))
                }
                sx={{
                    '& .MuiAccordionSummary-content': {
                        marginTop: '8px',
                        marginBottom: '8px',
                    },
                }}
                className="bg-white cursor-pointer border-0 mt-0"
            >
                <Row className="align-items-center">
                    <Col xs={8} className="d-flex align-items-center pl-0">
                        <CustomImageHandler
                            classes="user-img-rounded image-40"
                            photoPath={contract?.user?.profilePhoto?.thumbnail ?? ''}
                            altTag="Influencer logo"
                            name={fullName}
                        />
                        {isTruncated ? <TooltipOverlay content={fullName}>{h5Content}</TooltipOverlay> : h5Content}
                    </Col>
                    <Col xs={1} className="text-end d-flex align-items-center p-0">
                        <h6 className="mb-0 text-primary">
                            <Flag code={contract?.user?.contact?.country} className="rounded" width={33} />
                        </h6>
                    </Col>
                    <Col xs={2} className="text-end d-flex align-items-center p-0 justify-content-center">
                        <h6 className="mb-0 text-primary">
                            {(contract?.bookedPosts ?? 0) - (contract?.postingsUsed ?? 0)}
                        </h6>
                    </Col>
                    <Col xs={1} className="p-0 d-flex justify-content-end align-items-center">
                        {expended[contract?.id] ? (
                            <i className="fi fi-rr-angle-up font-14 text-dark"></i>
                        ) : (
                            <i className="fi fi-rr-angle-down font-14 text-dark"></i>
                        )}
                    </Col>
                </Row>
            </AccordionSummary>
            <AccordionDetails>
                <>
                    {contract.contractItems.map((contractItem, j) =>
                        contractItem.nbPosts - contractItem.postingsUsed > 0 ? (
                            <Row key={j} className="mb-2">
                                <Col xs={9}>
                                    {getSocialIcons({
                                        iconPath: contractItem?.socialPlatform?.path,
                                        dataTop: t(`general.platforms.${contractItem?.socialPlatform?.name}`),
                                        colorText: 'secondary',
                                    })}
                                </Col>
                                <Col xs={3} className="text-end">
                                    <p className="mb-0 text-primary">
                                        {contractItem.nbPosts - contractItem.postingsUsed}
                                    </p>
                                </Col>
                            </Row>
                        ) : null
                    )}
                </>
            </AccordionDetails>
        </Accordion>
    );
}
